export default {
  colors: {
    white: '#FFFFFF',
    black: '#000000',
    blueDark: '#00204a',
    blueHard: '#2b6b99a6',
    purple: '#6C63FF',
    purpleTransparent: '#6c63feb3',
    blue: '#6da8ff',
    heavenly: '#d9faff',
    blueTransparent: '#2b6d9985',
    textDescription: '#f3f3f3',
    dates: '#c0c0c0',
    h2: '#f7b226',
    sectionInner: '#191919'
  },
  fontSize: {
    xxs: 13,
    xs: 14,
    s: 16,
    m: 18,
    l: 20,
    xl: 26,
    xxl: 30
  }
};
